// extracted by mini-css-extract-plugin
export default {"contentContainer":"ConfirmationModalLauncher_contentContainer__jH7Bj","textContainer":"ConfirmationModalLauncher_textContainer__2ezi4"};